import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';

import config from 'config';
import LoginForm from './LoginForm';
import SubscribeForm from './SubscribeForm';
import NavigationMobile from './NavigationMobile';
import TransitionContainer from './TransitionContainer';
import { emailRegEx } from '../../../utils';

import './navigation.scss';

const duration = 500;

class Navigation extends PureComponent {
  state = {
    login: '',
    password: '',
    remember: false,
    email: '',
    phone: '',
    errors: {},
    name: '',
    surname: '',
    company: '',
    agreement: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.panel !== this.props.panel) {
      this.setState({ errors: {} });
    }
  }

  onSubmitSubscribe = (event) => {
    event.preventDefault();

    const errors = {};

    if (!this.state.name) {
      errors.name = 'Введите имя';
    }

    if (!this.state.surname) {
      errors.surname = 'Введите фамилию';
    }

    if (!this.state.company) {
      errors.company = 'Введите название компании';
    }

    if (!this.state.email) {
      errors.email = 'Введите пароль';
    }

    if (!this.state.agreement) {
      errors.agreement = 'error';
    }

    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      this.props.createSubscription({
        email: this.state.email,
        firstName: this.state.name,
        lastName: this.state.surname,
        company: this.state.company,
        privacyAgreed: this.state.agreement
      }).then(() => this.props.onPanelSwitch());
    }
  };

  onSubmitLogin = (event) => {
    event.preventDefault();

    const errors = {};

    if (!this.state.login) {
      errors.login = 'Введите логин';
    }
    if (!this.state.password) {
      errors.password = 'Введите пароль';
    }


    if (Object.keys(errors).length) {
      return this.setState({ errors });
    }
    fetch('https://api.uscapital.ru/api/auth', {
      method: 'POST',
      body: JSON.stringify({
        username: this.state.login,
        password: this.state.password,
        remember: this.state.remember
      })
    }).then((response) => response.json()).then((res) => {
      console.log(res);
      if (res.error) {
        errors.login = res.error.text;
        return this.setState({ errors });
      } else {
        document.cookie = 'token=' + res.userData.token + '; domain=.uscapital.ru; path=/';

        if (res.userData.token_rem) {
          let date = new Date();
          date.setTime(date.getTime() + (20 * 24 * 60 * 60 * 1000));
          document.cookie = 'token_rem='
            + res.userData.token_rem
            + '; expires=' + date.toUTCString()
            + '; domain=.uscapital.ru; path=/';
        }
        document.location.href = `${config.appProtocol}://my.uscapital.ru`;
      }
    });
  };

  onSubmitRecovery = (event) => {
    event.preventDefault();

    const errors = {};

    if (!this.state.email) {
      errors.email = 'Введите email';
    }

    if (this.state.email && !emailRegEx.test(this.state.email)) {
      errors.mail = 'Неправильный формат email';
    }

    if (!this.state.phone) {
      errors.phone = 'Введите контактный телефон';
    }

    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      console.log(this.state);
    }
  };

  onRememberChange = () => {
    this.setState({
      remember: !this.state.remember
    });
  };

  onAgreementChange = () => {
    this.setState({
      agreement: !this.state.agreement
    });
  };

  onFieldChange = (event) => {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  };

  render() {
    const open = !!this.props.panel;

    return (
      <div className={cn('navigation-container', { open })}>
        <div className="navigation-scroll">
          <button
            type="button"
            className="close-navigation"
            onClick={this.props.onPanelSwitch}
          />

          <div className="navigation-content">
            <Transition
              unmountOnExit={true}
              in={this.props.panel === 'navigation'}
              timeout={duration}
            >
              {(state) => (
                <TransitionContainer status={state} duration={duration}>
                  <NavigationMobile
                    links={this.props.links}
                    activeTabIndex={this.props.activeTabIndex}
                    onPanelSwitch={this.props.onPanelSwitch}
                  />
                </TransitionContainer>
              )}
            </Transition>

            <Transition
              unmountOnExit={true}
              in={this.props.panel === 'subscribe'}
              timeout={duration}
            >
              {(state) => (
                <TransitionContainer status={state} duration={duration}>
                  <SubscribeForm
                    name={this.state.name}
                    nameError={this.state.errors.name}
                    surname={this.state.surname}
                    surnameError={this.state.errors.surname}
                    company={this.state.company}
                    companyError={this.state.errors.company}
                    email={this.state.email}
                    emailError={this.state.errors.email}
                    agreement={this.state.agreement}
                    agreementError={this.state.errors.agreement}
                    onFieldChange={this.onFieldChange}
                    onAgreementChange={this.onAgreementChange}
                    onSubmit={this.onSubmitSubscribe}
                  />
                </TransitionContainer>
              )}
            </Transition>

            <Transition
              unmountOnExit={true}
              in={this.props.panel === 'login'}
              timeout={duration}
            >
              {(state) => (
                <TransitionContainer status={state} duration={duration}>
                  <LoginForm
                    login={this.state.login}
                    loginError={this.state.errors.login}
                    password={this.state.password}
                    passwordError={this.state.errors.password}
                    remember={this.state.remember}
                    rememberError={this.state.errors.remember}
                    onFieldChange={this.onFieldChange}
                    onRememberChange={this.onRememberChange}
                    onSubmit={this.onSubmitLogin}
                  />
                </TransitionContainer>
              )}
            </Transition>
          </div>

          <div className="navigation-footer">
            <div className="navigation-footer-container">
              <p className="address">
                +7 (383) 349-57-76<br />
                630099, Россия, г. Новосибирск<br />
                ул. Романова 28, 5 этаж<br />
                info@uscapital.ru<br />
              </p>
              <a
                href="https://e-disclosure.ru/portal/company.aspx?id=37308"
                target="_blank" rel="noopener noreferrer">Адрес раскрытия информации</a>
              <p className="copyright">
                © «Юнисервис Капитал», 2009–{new Date().getFullYear()}.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  activeTabIndex: PropTypes.number,
  links: PropTypes.array,
  panel: PropTypes.oneOf(['navigation', 'subscribe', 'login', 'recovery']),
  onPanelSwitch: PropTypes.func.isRequired,
  createSubscription: PropTypes.func.isRequired
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/index.js